<template>
  <div class="banner">
    <div :class="{ hidden: true }">
      <img :src="imgurl" alt="" :class="{ big_img: big, small_img: small }" />
      <div class="container">
        <p v-for="item in text" :key="item" class="text">
          {{ item }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgurl: {
      type: String,
      default: "",
    },
    text: {
      type: Array,
      default: () => [],
    },
    big: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  // cursor: pointer;
  // margin-bottom: 1rem;

  .hidden {
    position: relative;
    overflow: hidden;
    img {
      width: 100%;
    }
    .big_img {
      height: 9.8rem;
    }
    .container {
      position: absolute;
      right: 3%;
      bottom: 3%;
      transform: translateY(-50%);
      .text {
        text-align: left;
        color: rgb(255, 255, 255);
        font-size: 0.45rem;
        width: 100%;
        line-height: 1.2;
        font-weight: 600;
      }
    }
  }
}
@media screen and (max-width: 760px) {
  .banner {
    .hidden {
      .small_img {
        height: 60px;
      }
      .big_img {
        height: 100%;
      }
      .container {
        right: 3%;
        bottom: 0;
        .text {
          font-size: 0.4rem;
          line-height: 1.2;
        }
      }
    }
  }
}
// .banner {
//   // cursor: pointer;
//   // margin-bottom: 1rem;

//   .hidden {
//     position: relative;
//     overflow: hidden;
//     img {
//       width: 100%;
//     }
//     .big_img {
//       height: 9.8rem;
//     }
//     .container {
//       position: absolute;
//       left: 13%;
//       top: 50%;
//       transform: translateY(-50%);
//       .text {
//         text-align: left;
//         color: rgb(255, 255, 255);
//         font-size: 0.8rem;
//         width: 100%;
//         line-height: 1.1rem;
//         font-weight: 600;
//       }
//     }
//   }
// }
// @media screen and (max-width: 760px) {
//   .banner {
//     .hidden {
//       .small_img {
//         height: 60px;
//       }
//       .big_img {
//         height: 100%;
//       }
//       .container {
//         .text {
//           font-size: 0.45rem;
//           line-height: 1.5;
//         }
//       }
//     }
//   }
// }
</style>
